var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "dash" },
    [
      _c(
        "Headbar",
        { class: { full: _vm.activeScrolledNav }, attrs: { type: "dash" } },
        [
          _c(
            "a",
            {
              staticClass: "btn main txt-blk",
              class: { dslbd: _vm.tempHide },
              attrs: { href: "" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.fixedCta.apply(null, arguments)
                },
              },
            },
            [
              _c("span", { staticClass: "hvr" }),
              _vm._v(" "),
              _c("span", { staticClass: "ico" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "26",
                      height: "26",
                      viewBox: "0 0 26 26",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM11.5 11.5V6.5H14.5V11.5H19.5V14.5H14.5V19.5H11.5V14.5H6.5V11.5H11.5Z",
                        fill: "black",
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm.Global.currentDashboardStep === 1
                ? _c("span", { staticClass: "txt" }, [_vm._v("Add new row")])
                : _vm._e(),
              _vm._v(" "),
              _vm.Global.currentDashboardStep === 2
                ? _c("span", { staticClass: "txt" }, [
                    _vm._v("Add new content"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.Global.currentDashboardStep === 3
                ? _c("span", { staticClass: "txt" }, [
                    _vm._v("New Subscription plan"),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { ref: "wrapper", staticClass: "scroll-outer" }, [
        _c("div", { ref: "innerscroll", staticClass: "inner-scroll" }, [
          _c("div", { staticClass: "dash-outer" }, [
            _c("div", { staticClass: "container" }, [
              _c(
                "div",
                { staticClass: "lft" },
                [
                  _c("DashboardNav", {
                    style: { transform: "translateY(" + _vm.offY + "px)" },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { ref: "platState", staticClass: "platform-state-wrapper" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col platform-state",
                          style: _vm.stateStyle,
                        },
                        [
                          _c("div", { staticClass: "platform-state-inner" }, [
                            _c("div", { staticClass: "status-msg col" }, [
                              _c("p", [
                                _vm._v(
                                  "Change to your platform aren’t live yet."
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "ft-bld view txt-main" }, [
                                _c("span", { staticClass: "ico" }, [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "16",
                                        height: "11",
                                        viewBox: "0 0 18 12",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          "fill-rule": "evenodd",
                                          "clip-rule": "evenodd",
                                          d: "M18 5.99997L11.5236 0.476379L11.5236 5.00002H0V7.00002H11.5236L11.5236 11.5236L18 5.99997Z",
                                          fill: "#F5C952",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "txt",
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.openPreview.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("View current version")]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "actns" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "btn bck",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.rollback.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c("span", { staticClass: "txt" }, [
                                    _vm._v("Rollback"),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "btn main txt-blk",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.publish.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c("span", { staticClass: "hvr" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "txt" }, [
                                    _vm._v("Publish"),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "rgt" },
                [
                  _c(
                    "transition",
                    {
                      attrs: { name: _vm.transitype },
                      on: { "after-enter": _vm.onAfterEnter, css: false },
                    },
                    [_c("router-view")],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "b-overlay",
        class: { active: _vm.Global.activeBlurredOverlay },
      }),
      _vm._v(" "),
      _vm.Global.activeContentOverlay ? _c("ContentOverlay") : _vm._e(),
      _vm._v(" "),
      _vm.Global.activeRowOverlay ? _c("RowOverlay") : _vm._e(),
      _vm._v(" "),
      _vm.Global.activeDelOverlay ? _c("DeleteContentOverlay") : _vm._e(),
      _vm._v(" "),
      _vm.Global.activeDelRowOverlay ? _c("DeleteRowOverlay") : _vm._e(),
      _vm._v(" "),
      _vm.Global.activePlanOverlay ? _c("PlanOverlay") : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticClass: "h-overlay",
        class: { active: _vm.Global.activeHelperOverlay },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.helperBgClick.apply(null, arguments)
          },
        },
      }),
      _vm._v(" "),
      _vm.Global.ContentsHelperOverlayState == 1
        ? _c("ContentsHelperOverlay")
        : _vm._e(),
      _vm._v(" "),
      _vm.Global.RowsHelperOverlayState == 1
        ? _c("RowsHelperOverlay")
        : _vm._e(),
      _vm._v(" "),
      _vm.Global.windowWidth < 1025
        ? _c(
            "div",
            { staticClass: "resp-mess" },
            [
              _c("span", { staticClass: "caption ft-xbld txt-grt" }, [
                _vm._v("Hey there !"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "To add and edit your different contents, you really should be on a bigger resolution device."
                ),
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                { staticClass: "btn main lrg", attrs: { tag: "a", to: "/" } },
                [
                  _c("span", { staticClass: "txt" }, [
                    _vm._v("Back to homepage"),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }